import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "215.909 218.314 13.001 8.194",
  "content": "<symbol viewBox=\"215.909 218.314 13.001 8.194\" id=\"icon-arrow-down\">\r\n<g>\r\n\t<path d=\"M228.6,219.248l-0.625-0.625c-0.218-0.206-0.471-0.31-0.76-0.31c-0.295,0-0.545,0.104-0.751,0.31l-4.055,4.055\r\n\t\tl-4.056-4.055c-0.207-0.206-0.457-0.31-0.752-0.31c-0.289,0-0.541,0.104-0.759,0.31l-0.616,0.626\r\n\t\tc-0.211,0.211-0.317,0.464-0.317,0.759c0,0.3,0.106,0.551,0.317,0.751l5.432,5.432c0.201,0.212,0.451,0.317,0.751,0.317\r\n\t\tc0.295,0,0.548-0.105,0.76-0.317l5.433-5.432c0.205-0.206,0.309-0.457,0.309-0.751C228.909,219.718,228.807,219.465,228.6,219.248z\r\n\t\t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-down.svg
// module id = jIbX
// module chunks = 0